// This is a modal for Adminfaqone
import { Button as AIMEButton } from "tot-loft-component-library";
import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addFaqsItem, updateFaqsItem } from "./redux/slices/FaqsThunks";
import { addFaqsHistory } from "./redux/slices/FaqshistoryThunks";

export default function ModalAdminfaqadd({ onClose, type, data, setData }) {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  const handler = async () => {
    const date = Date.now();
    const data = {
      question: question,
      answer: answer,
      created_at: date,
      updated_at: date,
    };
    await dispatch(addFaqsItem(data));
    onClose();
  };

  const editHandler = async () => {
    const date = Date.now();
    const editData = {
      faq_id: data._id,
      question: data.question,
      answer: data.answer,
      updated_at: date,
    };
    var newData = { ...data };
    newData.updated_at = date;
    const res = await dispatch(addFaqsHistory(editData));
    const updateRes = await dispatch(updateFaqsItem(newData));
    onClose();
  };

  return (
    <RootWrapperModalAdminfaqone>
      <Overlay>
        <Wrapper>
          <TermsAndCondtions>
            <Left>
              <Frame58>
                <Frame1391>
                  <UpdateHistory>
                    {type == "Add" ? "Add" : "Edit"} FAQ
                  </UpdateHistory>
                  <PRTNR.Input
                    label={"Question"}
                    value={type == "Add" ? question : data?.question}
                    onChange={(e) => {
                      type == "Add"
                        ? setQuestion(e.target.value)
                        : setData({ ...data, question: e.target.value });
                    }}
                  />
                  <PRTNR.TextArea
                    label={"Answer"}
                    value={type == "Add" ? answer : data?.answer}
                    onChange={(e) => {
                      type == "Add"
                        ? setAnswer(e.target.value)
                        : setData({ ...data, answer: e.target.value });
                    }}
                  />
                </Frame1391>
                <Frame1416>
                  <AIMEButton
                    size="small"
                    onClick={() => {
                      setQuestion("");
                      setAnswer("");
                      setData("");
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      background: "rgb(241, 245, 249)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Clear
                    </span>
                  </AIMEButton>

                  <AIMEButton
                    size="small"
                    onClick={() => {
                      type == "Add" ? handler() : editHandler();
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      gap: "10px",
                      borderRadius: "48px",
                      width: "240px",
                      background: "rgb(97, 98, 197)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Save
                    </span>
                  </AIMEButton>
                </Frame1416>
              </Frame58>
            </Left>
          </TermsAndCondtions>
        </Wrapper>
      </Overlay>
    </RootWrapperModalAdminfaqone>
  );
}

const RootWrapperModalAdminfaqone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  padding: 40px 24px 24px;
`;

const TermsAndCondtions = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const UpdateHistory = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1416 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
